import { useWorldSelectionRectangle } from 'hooks/map/useWorldSelectionRectangle';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';

export const useMouseActions = () => {
    const ctxEdit = useContext(CtxEdit);
    const worldSelectionRectangle = useWorldSelectionRectangle(ctxEdit.mapRef?.current?.getZoom());

    function forSingleClick(marker, isCtrlDown) {
        if (marker || isCtrlDown) {
            console.log(
                '%c Selecting marker hook',
                'background-color: yellow',
                marker?.elementType,
                marker?.id
            );
            if (isCtrlDown) {
                ctxEdit.setSelectedMarkers([...ctxEdit.selectedMarkers, marker.id]);
            } else {
                ctxEdit.setSelectedMarkers([marker.id]);
            }
        } else {
            ctxEdit.setSelectedMarkers([]);
        }
    }

    function forMultiSelect(e) {
        console.log('Start rectangle', e.x, e.y);
        worldSelectionRectangle.startSelection(
            e.x - ctxEdit.boundingExtra.x,
            e.y - ctxEdit.boundingExtra.y
        );
    }

    function forShiftSelect(marker) {
        if (marker) {
            console.log(
                '%c Selecting marker hook',
                'background-color: orange',
                marker.elementType,
                [...ctxEdit.selectedMarkers, marker.id]
            );
            ctxEdit.setSelectedMarkers([...ctxEdit.selectedMarkers, marker.id]);
        }
    }

    function forMultiSelectUpdateDimensions(e) {
        worldSelectionRectangle.moveSelectionUpdate(
            e.x - ctxEdit.boundingExtra.x,
            e.y - ctxEdit.boundingExtra.y
        );
    }

    return {
        forSingleClick,
        forMultiSelect,
        forShiftSelect,
        forMultiSelectUpdateDimensions
    };
};
